module.exports = __webpack_public_path__ + "img/galeria-captores-8.0d23f411.png";